import { LayoutUrl, StringUtil } from "@mcleod/core";
import { AutogenLayoutScreenCodesQuickInfo } from "./autogen/AutogenLayoutScreenCodesQuickInfo";

export class ScreenCodesQuickInfo extends AutogenLayoutScreenCodesQuickInfo {

    override onLoad() {
        this.textboxFieldCode.addDataDisplayListener(() => {
            this.textboxFieldCode.printableLabel.link = this.getScreenCodeLink();
        })
    }

    private getScreenCodeLink(): string {
        const fieldTableAlias = this.activeRow?.get("field_table_alias");
        const fieldName = this.activeRow?.get("field_name");
        const fieldCode = this.activeRow?.get("field_code");
        const validValues = [fieldTableAlias, fieldName, fieldCode].every(field => !StringUtil.isEmptyString(field));
        if (!validValues)
            return null;

        return LayoutUrl.create("lme/dispatch/ScreenCode", {
            mode: "update",
            key: `${fieldTableAlias},${fieldName},${fieldCode}`
        });
    }
}
